import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useState } from 'react';
import { HUBSPOT_CREDITS_CARD } from '../../constants/tracking/TrackingSources';
import { TalkToSalesFallback } from '../../features/purchaseMotions/components/TalkToSalesFallback';
import { useAppSelector } from '../../reducers';
import { billingNameKeySelector, productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { queryParamTermSelector } from '../../selectors/QueryParamTermSelectors';
import ErrorBoundary from '../error-boundary/ErrorBoundary';
import { AddOnCardCTA } from './AddOnCardCTA';
import AddOnCardLayoutUI from './AddOnCardLayoutUI';
import { HubSpotCreditsPricing } from './HubSpotCreditsPricing';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubSpotCreditsCard = ({
  screen,
  skuId
}) => {
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const queryParamTerm = useAppSelector(queryParamTermSelector);
  const productConfigurations = [createProductConfig({
    skuId,
    quantity: selectedQuantity
  })];
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  return /*#__PURE__*/_jsx(AddOnCardLayoutUI, {
    "data-test-id": `${HUBSPOT_CREDITS_CARD}-${product.apiName}`,
    "data-selenium-id": `${HUBSPOT_CREDITS_CARD}-${product.apiName}`,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages.products.${billingNameKey}.title`
    }),
    pricing: /*#__PURE__*/_jsx(HubSpotCreditsPricing, {
      productConfigurations: productConfigurations,
      skuId: skuId,
      term: queryParamTerm
    }),
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.addOns.cards.hubSpotCredits.subtitle"
    }),
    cta: /*#__PURE__*/_jsx(ErrorBoundary, {
      fallback: /*#__PURE__*/_jsx(TalkToSalesFallback, {
        apiName: product.apiName,
        trackingSource: HUBSPOT_CREDITS_CARD,
        screen: screen
      }),
      children: /*#__PURE__*/_jsx(AddOnCardCTA, {
        skuId: skuId,
        screen: screen,
        trackingSource: HUBSPOT_CREDITS_CARD,
        term: queryParamTerm,
        selectedQuantity: selectedQuantity,
        productConfigurations: productConfigurations,
        onQuantityChange: setSelectedQuantity
      })
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `pricing-pages.products.${billingNameKey}.paragraph`
    })
  });
};
export default HubSpotCreditsCard;